import type { EmployeeAlertInvalidEmployeeCode } from '@/common/graphql';

import { FormattedDate } from '../FormattedDate';

export const DetailDescriptionEmployeeAlertInvalidEmployeeCode = ({
  reason,
}: {
  reason: Pick<EmployeeAlertInvalidEmployeeCode, 'contractStartDate' | 'employeeCode' | 'detailMessage'>;
}) => (
  <>
    <div>
      <FormattedDate prefix="Contract start date" date={reason.contractStartDate} />
    </div>
    <div>
      Employee code:&nbsp;
      {reason.employeeCode}
    </div>
    <div>
      Reason:&nbsp;
      {reason.detailMessage}
    </div>
  </>
);
